import React from "react";
import HomeSideNavBar from "./HomeSideNavBar";
import Header from "./Header";
import ApiDataProvider from "./ApiDataContext";
import ReportsLayout from "../features/reports/ReportsLayout";

/**
 * Reports page shell. The previous nested-tab navigator (device-type
 * group tab → sub-report tab) is replaced by a single left-rail
 * navigator with grouped sections + search + recents — see
 * features/reports/ReportsLayout. The legacy report components are
 * imported and rendered untouched inside the right pane.
 */
function Reports() {
  return (
    <ApiDataProvider>
      <div className="container">
        <div className="screen-layout">
          <Header />
          <HomeSideNavBar />
          <ReportsLayout />
        </div>
      </div>
    </ApiDataProvider>
  );
}

export default Reports;
